import { applySpec } from 'ramda';
import { useMemo } from 'react';

import { useAppState } from '@ezugi/bootstrap/src/hooks/useAppState';
import { useIntl } from '@ezugi/bootstrap/src/hooks/useIntl';
import { Dice } from '@ezugi/primitives';
import { DeviceInfo } from '@ezugi/utils';

import { gameResultsSelector } from '../../../store/selectors/game';
import { Container, DiceWrapper, Details } from './style';

const intlKeys = {
  small: 'bets.small',
  big: 'bets.big',
  triple: 'sicbo_ui.triple',
};

const spec = applySpec({
  gameResults: gameResultsSelector,
});

const DICE_PROPS = {
  width: DeviceInfo.isHandheld ? 22 : 46,
  height: DeviceInfo.isHandheld ? 22 : 46,
};

export default function ResultDisplay() {
  const [
    {
      gameResults: {
        DiceOne,
        DiceTwo,
        DiceThree,
      } = {},
    },
  ] = useAppState(spec);
  const locales = useIntl({ keys: intlKeys });

  const resultDetails = useMemo(() => {
    if (DiceOne && DiceTwo && DiceThree) {
      if (DiceOne === DiceTwo && DiceOne === DiceThree) {
        return `${locales.triple} - ${DiceOne}`;
      }
      const total = DiceOne + DiceTwo + DiceThree;
      return `${total <= 10 ? locales.small : locales.big} - ${total}`;
    }
    return '';
  }, [ DiceOne, DiceTwo, DiceThree, locales ]);

  return (
    <Container data-name="result-display">
      <DiceWrapper>
        <Dice value={DiceOne} {...DICE_PROPS} />
        <Dice value={DiceTwo} {...DICE_PROPS} />
        <Dice value={DiceThree} {...DICE_PROPS} />
      </DiceWrapper>
      {resultDetails && (
        <Details>
          {resultDetails}
        </Details>
      )}
    </Container>
  );
}
